<template>
    <b-select id="select-app" v-model="appSelected" :placeholder="placeholder" @input="callEvents" v-show="apps.length > 1" :expanded="expanded" :disabled="disabled">
        <option :value="null" v-if="nullable">{{placeholder}}</option>
        <option v-for="(app,key) in apps" :key="key" :value="app.id">{{app.name}}</option>
    </b-select>
</template>
<script>
import Vue from "vue";
import _ from 'lodash';

export default {
    props:{
        preSelect:{
            default:null
        },
        nullable:{
            default:false
        },
        value:{
            required: true
        },
        expanded:{
            default:false
        },
        placeholder:{
            default: 'All Applications'
        },
        noAppTitle:{
            default: null
        },
        disabled:{
            default:false
        }
    },
    data() {
        return {
            appSelected:null,
            apps:[]
        }
    },
    model: {
        event: 'change'
    },
    mounted() {
        this.getAppList();
    },
    computed:{
        referrer() {
            return document.referrer
        },
    },
    watch:{
        value(){
            this.appSelected = this.value
        }
    },
    methods:{
        async getAppList() {
            if(this.$store.state.apps.length){
                this.apps = this.$store.state.apps
            }else{
                await Vue.$appService.appList().then((response)=>{
                    this.apps = response
                    this.$store.commit('SET_APPS',response)
                })
            }
            if(this.preSelect){
                let appSelected = this.preSelect
                this.getApp(appSelected).then((app)=>{
                    if(app && this.apps.length>1){
                        // this.$refs.apps.setSelected(app)
                        this.appSelected = app.id
                        this.callEvents(this.appSelected)
                        // this.$emit('input',this.appSelected);
                    }else{
                        this.appSelected = null
                        this.callEvents(this.appSelected)
                    }
                })
            }else if(this.referrer!==''){
                let referrer = this.referrer
                let app = _.find(this.apps,(value)=>{
                    return referrer.includes(value.referrer)
                })
                if(app && this.apps.length>1){
                    this.appSelected = app.id
                    this.callEvents(this.appSelected)
                }

            }else if(this.apps.length===1){
                this.$emit('appSingle', true)
                this.appSelected = this.apps[0].id
                this.callEvents(this.appSelected)
            }
        },
        getApp(appSelected){
            return new Promise((resolve)=>{
                resolve(_.find(this.apps,(value)=>{
                    return appSelected === value.id
                }))
            });
        },
        callEvents(event){
            this.$emit('change', event)
            this.$emit('input',this.appSelected);
        }
    }
}
</script>